import { render, staticRenderFns } from "./express-company-tab.vue?vue&type=template&id=65a6167d"
import script from "./express-company-tab.vue?vue&type=script&lang=js"
export * from "./express-company-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports